import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 控制台-路由
export const workbench_routes = [
	{
        path: '',
        show: false,
		redirect: 'essu/list',
	},
	// 分析
	// {
	// 	path: 'analyze',
	// 	cname: '分析',
	// 	component: () => import('@/views/workbench/Analyze.vue')
	// },
	// // 待办事项
	// {
	// 	path: 'to-do',
	// 	cname: '待办事项',
	// 	component: () => import('@/views/workbench/MyExperiment.vue')
	// },
	// // 我的试验
	// {
	// 	path: 'my-experiment',
	// 	cname: '我的试验',
	// 	component: () => import('@/views/workbench/MyExperiment.vue')
	// },
	// // 我的中心
	// {
	// 	path: 'my-center',
	// 	cname: '我的中心',
	// 	component: () => import('@/views/workbench/MyExperiment.vue')
	// },
	// // 我的研究者
	// {
	// 	path: 'my-researcher',
	// 	cname: '我的研究者',
	// 	component: () => import('@/views/workbench/MyExperiment.vue')
	// },
	// // 我的团队
	// {
	// 	path: 'my-team',
	// 	cname: '我的团队',
	// 	component: () => import('@/views/workbench/MyExperiment.vue')
	// },
    {
        path:'essu',
        cname: 'ESSU',
        show: true,
        component: () => import('@/views/workbench/essu.vue'),
        children: [
            {
                path: 'list',
                cname: '我的调研',
                name: 'essulist',
                show: true,
                component: () => import('@/views/workbench/essu/list.vue'),
                meta: {
                    title: {
                        'zh-cn': '决策分析-临研查数字化智库平台',
                        'en-us': 'digitalgcp'
                    }
                },
            },
            {
                path: 'save',
                cname: '添加问卷',
                name: 'essusave',
                show: false,
                component: () => import('@/views/workbench/essu/save.vue'),
                meta: {
                    title: {
                        'zh-cn': '决策分析-临研查数字化智库平台',
                        'en-us': 'digitalgcp'
                    }
                },
            },
        ]
    },
	// // 工时管理
	// {
	// 	path: 'working-hours-management',
	// 	cname: '工时管理',
	// 	component: () => import('@/views/workbench/MyExperiment.vue')
	// },
	// 个人设置
	// {
	// 	path: 'personal-settings',
	// 	cname: '个人设置',
	// 	name: 'WorkbenchPersonalSettings',
	// 	component: () => import('@/views/workbench/MyExperiment.vue')
	// },
	// // 权限管理
	// {
	// 	path: 'authority-management',
	// 	cname: '权限管理',
	// 	component: () => import('@/views/workbench/MyExperiment.vue')
	// },
	// 公告
	// {
	// 	path: 'announcement',
	// 	cname: '公告',
	// 	name: 'WorkbenchAnnouncement',
	// 	component: () => import('@/views/workbench/MyExperiment.vue')
	// },
	// 帮助
	// {
	// 	path: 'help',
	// 	cname: '帮助',
	// 	name: 'WorkbenchHelp',
	// 	component: () => import('@/views/workbench/MyExperiment.vue')
	// },
	// // 日志
	// {
	// 	path: 'log',
	// 	cname: '日志',
	// 	component: () => import('@/views/workbench/MyExperiment.vue')
	// },
];

export const dbCardName = ["yaopinzz", "hcgy", "yiyaozjt"];
export const reportListName = ["report-drug"];

const routes = [
	{
		path: '/',
		component: () => import('@/views/Base.vue'),
		children: [
			{
				path: '',
				name: 'index',
				component: () => import('@/views/index/Index.vue'),
                meta: {
                    title: {
                        'zh-cn': '临研查数字化智库平台 - 重庆药达大数据有限公司',
                        'en-us': 'digitalgcp'
                    }
                },
			},
			// 登录页面
			{
				path: 'login',
				name: 'login',
				component: () => import('@/views/login/Index.vue'),
			},
            // 试用申请
            {
                path: 'apply',
                name: 'apply',
                component: () => import('@/views/login/apply.vue'),
            },
            // 其他模块
			{
				path: 'other',
				name: 'other',
				component: () => import('@/views/other/index.vue'),
				redirect: '/',
				children: [
					{
						path: 'emailclick',
						name: 'other_emailclick',
						component: () => import('@/views/other/emailclick.vue'),
                    },
                    {
                        path: 'essu',
                        name: 'other_essu',
                        component: () => import('@/views/other/essu/base.vue'),
                        children: [
                            {
                                path: 'investigate/:cid([A-Z0-9-]{15})',
                                name: 'other_essu_investigate',
                                component: () => import('@/views/other/essu/investigate.vue'),
                            },
                            {
                                path: 'signature/:cid([A-Z0-9-]{15})',
                                name: 'other_essu_signature',
                                component: () => import('@/views/other/essu/signature.vue'),
                                meta: {
                                    title: {
                                        'zh-cn': '签名-临研查数字化智库平台',
                                        'en-us': 'digitalgcp'
                                    }
                                }
                            },
                            {
                                path: 'content',
                                name: 'other_essu_content',
                                component: () => import('@/views/other/essu/content.vue'),
                            },
                        ]
                    },
				]
			},
			// 设置页面
			{
				path: 'settings',
				name: 'Settings',
				component: () => import('@/views/Settings.vue'),
			},
			// 通用搜索页面-列表
			// {
			// 	path: '',
			// 	redirect: 'research_center',
			// },
			{
				name: 'research_center',
				path: 'research_center',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '研究中心列表-临研查数字化智库平台',
						'en-us': 'research center digitalgcp'
					}
				}
			},
			{
				name: 'researcher',
				path: 'researcher',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '研究者列表-临研查数字化智库平台',
						'en-us': 'researcher digitalgcp'
					}
				},
			},
			{
				name: 'researcher_risk',
				path: 'researcher_risk',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '研究者风险信息-临研查数字化智库平台',
						'en-us': 'researcher risk information digitalgcp'
					}
				},
			},
			{
				name: 'experiment',
				path: 'experiment',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': 'CTR试验列表-临研查数字化智库平台',
						'en-us': 'experiment digitalgcp'
					}
				}
			},
			{
				name: 'chictr',
				path: 'chictr',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': 'CHI试验列表-临研查数字化智库平台',
						'en-us': 'chictr digitalgcp'
					}
				}
			},
			{
				name: 'linchuangus',
				path: 'linchuangus',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '美国试验列表-临研查数字化智库平台',
						'en-us': 'US clinical trial digitalgcp'
					}
				}
			},
			{
				name: 'linchuangkr',
				path: 'linchuangkr',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '韩国试验列表-临研查数字化智库平台',
						'en-us': 'Korea clinical trial digitalgcp'
					}
				}
			},
			{
				name: 'linchuangjp',
				path: 'linchuangjp',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '日本试验列表-临研查数字化智库平台',
						'en-us': 'Japanese clinical trial digitalgcp'
					}
				}
            },
            {
                name: 'linchuangau',
                path: 'linchuangau',
                component: () => import('@/views/search/Index.vue'),
                meta: {
                    title: {
                        'zh-cn': '澳洲试验列表-临研查数字化智库平台',
                        'en-us': 'Australia clinical trial digitalgcp'
                    }
                }
            },
			{
				name: 'sponsor',
				path: 'sponsor',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '申办方列表-临研查数字化智库平台',
						'en-us': 'sponsor digitalgcp'
					}
				}
			},
			{
				name: 'cro',
				path: 'cro',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': 'CRO列表-临研查数字化智库平台',
						'en-us': 'cro digitalgcp'
					}
				}
			},
			{
				name: 'lab',
				path: 'lab',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '第三方实验室列表-临研查数字化智库平台',
						'en-us': 'lab digitalgcp'
					}
				}
			},
			{
				name: 'smo',
				path: 'smo',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '现场管理组织SMO-临研查数字化智库平台',
						'en-us': 'smo digitalgcp'
					}
				}
			},
			{
				name: 'supplier',
				path: 'supplier',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '其他供应商-临研查数字化智库平台',
						'en-us': 'other supplier digitalgcp'
					}
				}
			},
			{
				name: 'medicalguide',
				path: 'medicalguide',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '医学指南列表-临研查数字化智库平台',
						'en-us': 'medicalguide digitalgcp'
					}
				}
			},
			{
				name: 'guideprinciple',
				path: 'guideprinciple',
				component: () => import('@/views/search/Index.vue'),
				meta: {
					title: {
						'zh-cn': '指导原则列表-临研查数字化智库平台',
						'en-us': 'guideprinciple digitalgcp'
					}
				}
			},
			// 决策分析
			{
				name: 'strategic',
				path: 'strategic',
				component: () => import('@/views/strategic/StrategicAnalysis.vue'),
				meta: {
					title: {
						'zh-cn': '决策分析-临研查数字化智库平台',
						'en-us': 'digitalgcp'
					}
				},
			},
			// 报告
			// {
			// 	path: 'report',
			// 	component: () => import('@/views/report/Base.vue'),
			// 	redirect: '/report',
			// 	children: [
            //         {
            //             name: 'report',
			// 			path: '/report',
			// 			cname: '药物报告',
			// 			show: true,
			// 			component: () => import('@/views/report/Index.vue'),
			// 			meta: {
			// 				title: {
			// 					'zh-cn': '药物报告-临研查数字化智库平台',
			// 					'en-us': 'digitalgcp'
			// 				}
			// 			},
			// 		},
			// 	],
			// },
			// 报告详情
			// {
			// 	name: 'reportDetail',
			// 	path: '/report/:oid',
			// 	component: () => import('@/views/report/reportDrug/Detail.vue'),
			// 	meta: {
			// 		title: {
			// 			'zh-cn': '报告详情-临研查数字化智库平台',
			// 			'en-us': 'report Detail digitalgcp'
			// 		}
			// 	}
			// },
			// 中控台
			{
				path: 'workbench',
				component: () => import('@/views/workbench/Base.vue'),
				redirect: '/workbench/index',
				children: workbench_routes,
			},
			// 通用搜索页面-详情
			{
				path: 'research_center/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'ResearchCenterDetail',
						path: '',
						component: () => import('@/views/search/detail/ResearchCenter.vue'),
						meta: {
							title: {
								'zh-cn': '研究中心详情-临研查数字化智库平台',
								'en-us': 'ResearchCenter Detail digitalgcp'
							}
						}
					}
				]
			},
			{
				path: 'experiment/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'ExperimentDetail',
						path: '',
						component: () => import('@/views/search/detail/Experiment.vue'),
						meta: {
							title: {
								'zh-cn': 'CTR试验详情-临研查数字化智库平台',
								'en-us': 'Experiment Detail digitalgcp'
							}
						}
					}
				]
			},
			{
				path: 'chictr/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'ChictrDetail',
						path: '',
						component: () => import('@/views/search/detail/Chictr.vue'),
						meta: {
							title: {
								'zh-cn': 'CHI试验详情-临研查数字化智库平台',
								'en-us': 'US clinical trial Detail digitalgcp'
							}
						},
					}
				]
			},
			{
				path: 'linchuangus/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'linchuangusDetail',
						path: '',
						component: () => import('@/views/search/detail/Linchuangus.vue'),
						meta: {
							title: {
								'zh-cn': '美国临床详情-临研查数字化智库平台',
								'en-us': 'digitalgcp'
							}
						}
					}
				]
			},
			{
				path: 'linchuangkr/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'linchuangkrDetail',
						path: '',
						component: () => import('@/views/search/detail/Linchuangkr.vue'),
						meta: {
							title: {
								'zh-cn': '韩国临床详情-临研查数字化智库平台',
								'en-us': 'Korea clinical trial Detail digitalgcp'
							}
						}
					}
				]
			},
			{
				path: 'linchuangjp/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'linchuangjpDetail',
						path: '',
						component: () => import('@/views/search/detail/Linchuangjp.vue'),
						meta: {
							title: {
								'zh-cn': '日本试验列表-临研查数字化智库平台',
								'en-us': 'Japanese clinical trial Detail digitalgcp'
							}
						}
					}
				]
            },
            {
                path: 'linchuangau/:oid',
                component: () => import('@/views/search/detail/Base.vue'),
                children: [
                    {
                        name: 'linchuangauDetail',
                        path: '',
                        component: () => import('@/views/search/detail/Linchuangau.vue'),
                        meta: {
                            title: {
                                'zh-cn': '澳洲临床详情-临研查数字化智库平台',
                                'en-us': 'Australia clinical trial Detail digitalgcp'
                            }
                        }
                    }
                ]
            },
			{
				path: 'sponsor/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'SponsorDetail',
						path: '',
						component: () => import('@/views/search/detail/Sponsor.vue'),
						meta: {
							title: {
								'zh-cn': '申办方详情-临研查数字化智库平台',
								'en-us': 'Sponsor Detail digitalgcp'
							}
						}
					}
				]
			},
			{
				path: 'researcher/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'ResearcherDetail',
						path: '',
						component: () => import('@/views/search/detail/Researcher.vue'),
						meta: {
							title: {
								'zh-cn': '研究者详情-临研查数字化智库平台',
								'en-us': 'Researcher Detail digitalgcp'
							}
						}
					}
				]
			},
			{
				path: 'cro/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'CroDetail',
						path: '',
						component: () => import('@/views/search/detail/Cro.vue'),
						meta: {
							title: {
								'zh-cn': '合同研究组织CRO详情-临研查数字化智库平台',
								'en-us': 'Cro Detail digitalgcp'
							}
						}
					}
				]
			},
			{
				path: 'lab/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'LabDetail',
						path: '',
						component: () => import('@/views/search/detail/Lab.vue'),
						meta: {
							title: {
								'zh-cn': '第三方实验室LAB详情-临研查数字化智库平台',
								'en-us': 'Lab Detail digitalgcp'
							}
						}
					}
				]
			},
			{
				path: 'smo/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'SmoDetail',
						path: '',
						component: () => import('@/views/search/detail/Smo.vue'),
						meta: {
							title: {
								'zh-cn': '临床试验现场组织管理SMO详情-临研查数字化智库平台',
								'en-us': 'Smo Detail digitalgcp'
							}
						}
					}
				]
			},
			{
				path: 'supplier/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'SupplierDetail',
						path: '',
						component: () => import('@/views/search/detail/Supplier.vue'),
						meta: {
							title: {
								'zh-cn': '临床试验现场组织管理Supplier详情-临研查数字化智库平台',
								'en-us': 'Supplier Detail digitalgcp'
							}
						}
					}
				]
			},
			{
				path: 'medicalguide/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'MedicalGuideDetail',
						path: '',
						component: () => import('@/views/search/detail/Medicalguide.vue'),
						meta: {
							title: {
								'zh-cn': '医学指南详情-临研查数字化智库平台',
								'en-us': 'MedicalGuide Detail digitalgcp'
							}
						}
					},
				]
			},
			{
				path: 'guideprinciple/:oid',
				component: () => import('@/views/search/detail/Base.vue'),
				children: [
					{
						name: 'GuideprincipleDetail',
						path: '',
						component: () => import('@/views/search/detail/Guideprinciple.vue'),
						meta: {
							title: {
								'zh-cn': '医学指南详情-临研查数字化智库平台',
								'en-us': 'Guideprinciple Detail digitalgcp'
							}
						}
					},
				]
            },
            {
                path: 'researcher_risk/:oid',
                component: () => import('@/views/search/detail/Base.vue'),
                children: [
                    {
                        name: 'ResearcherRiskDetail',
                        path: '',
                        component: () => import('@/views/search/detail/ResearcherRisk.vue'),
                        meta: {
                            title: {
                                'zh-cn': '研究者风险信息-临研查数字化智库平台',
                                'en-us': 'Research risk Detail digitalgcp'
                            }
                        }
                    },
                ]
            },
		],
	},
	{
		path: '/forbidden',
		component: () => import('@/views/error/403.vue')
	},
	// 404 页面，iframe占位
	{
		path: '/404_iframe',
		component: () => import('@/views/error/404_iframe.vue'),
	},
	{
		path: '404',
		component: () => import('@/views/error/404.vue')
	},
	{
		path: '*',
		component: () => import('@/views/error/404.vue')
	}
];


const router = new Router({
	mode: 'history',
	routes,
});

export default router;
